var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"game",staticClass:"Game"},[_c('DragShadow'),_c('GameHeader'),_c(_vm.mainComponent,{tag:"Component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }